const sorts = {
  asc: 'asc',
  desc: 'desc',
};

const sortListLabels = {
  order: [
    {
      label: 'Crescente',
      sort: sorts.asc,
    },
    {
      label: 'Decrescente',
      sort: sorts.desc,
    },
  ],
  sort: [
    {
      label: 'A - Z',
      sort: sorts.asc,
    },
    {
      label: 'Z - A',
      sort: sorts.desc,
    },
  ],
  type: [
    {
      label: 'Lote',
      sort: sorts.desc,
    },
    {
      label: 'Individual',
      sort: sorts.asc,
    },
  ],
  status: [
    {
      label: 'Concluídos',
      sort: sorts.asc,
    },
    {
      label: 'Erros',
      sort: sorts.desc,
    },
  ],
  date: [
    {
      label: 'Mais recente',
      sort: sorts.desc,
    },
    {
      label: 'Mais antiga',
      sort: sorts.asc,
    },
  ],
  amount: [
    {
      label: 'Máximo valor',
      sort: sorts.desc,
    },
    {
      label: 'Mínimo valor',
      sort: sorts.asc,
    },
  ],
  history: [
    {
      label: 'Mais recente - mais antiga',
      sort: sorts.desc,
    },
    {
      label: 'Mais antiga - mais recente',
      sort: sorts.asc,
    },
  ],
};

type List = typeof sortListLabels.sort;

export const sortTypes = {
  created: 'created',
  file: 'filename',
  status: 'status',
  campaignName: 'campaignName',
  destiny: 'destiny',
  type: 'type',
  miles: 'amount',
};

export const beneficiariesSort: { [x: string]: { type: string; labels: List } } = {
  Data: {
    type: sortTypes.created,
    labels: sortListLabels.date,
  },
  'Nome da campanha': {
    type: sortTypes.campaignName,
    labels: sortListLabels.sort,
  },
  Destino: {
    type: sortTypes.destiny,
    labels: sortListLabels.sort,
  },
  'Tipo de envio': {
    type: sortTypes.type,
    labels: sortListLabels.type,
  },
  Milhas: {
    type: sortTypes.miles,
    labels: sortListLabels.amount,
  },
  Status: {
    type: sortTypes.status,
    labels: sortListLabels.status,
  },
};

export const historySort: { type: string; labels: List } = {
  type: sortTypes.created,
  labels: sortListLabels.history,
};
